import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'

export type TitleIdToNotification = {
  [titleId: string]: WpsTypes.atv.wps.NotificationFragmentModelProps | undefined
}

export const reducer = createMergeReducer(
  t => t.notification,
  {} as TitleIdToNotification
)
